import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { Ticket } from 'src/app/models/ticket/ticket.model';

@Component({
  selector: 'app-ticket-detail-contact',
  templateUrl: './ticket-detail-contact.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TicketDetailContactComponent {
  readonly ticket = input.required<Ticket>();

  readonly initials = computed(() =>
    (this.ticket()?.Contact?.Name ?? '')
      .split(' ')
      .slice(0, 2)
      .map((p) => p[0]?.toUpperCase() ?? '')
      .join(''),
  );
}
